import React from 'react';
import ReactDOM from 'react-dom/client';
// Font Roboto (chuẩn toàn umbrella — Noon làm gốc); subset latin+vietnamese, 400/500.
import '@fontsource/roboto/latin-400.css';
import '@fontsource/roboto/latin-500.css';
import '@fontsource/roboto/vietnamese-400.css';
import '@fontsource/roboto/vietnamese-500.css';
import { ConfigProvider } from 'antd';
import viVN from 'antd/locale/vi_VN';
import enUS from 'antd/locale/en_US';
import { BrowserRouter } from 'react-router-dom';
import { buildThemeConfig, createI18n, useUiStore, installAutocompleteOff } from '@fms/shared';
import { authResources } from '@zero/auth-admin-ui';
import { AppShell } from './App.jsx';
import vi from './i18n/vi.json';
import en from './i18n/en.json';

createI18n({ moduleVi: vi, moduleEn: en, authResources });

// Quy tắc cross-module FMS HACT: tắt autocomplete cho mọi ô nhập text toàn site.
installAutocompleteOff();

function Root() {
  const themeMode = useUiStore((s) => s.themeMode);
  const locale = useUiStore((s) => s.locale);
  return (
    <ConfigProvider
      locale={locale === 'vi' ? viVN : enUS}
      theme={buildThemeConfig(themeMode)}
    >
      <BrowserRouter basename="/fms">
        <AppShell />
      </BrowserRouter>
    </ConfigProvider>
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
